<template>
  <div class="btn-group" role="group" aria-label="tab button group">
    <button v-for="(tab, i) in tabs" :key="i" :class="tab.tabCss" @click="btnChange(tab.tabNo)">
      {{ tab.tabName }}
    </button>
  </div>
</template>
<script>

export default {
    name:'Tab',
    props:{
        tab:{
            type:Array,
            required:true,
        },
        activeBtn:{
            type: Boolean,
            required: true
        }
    },
    data(){
        return {
            tabs: []
        }
    },
    mounted() {
        this.tabs = this.tab;
    },
    methods: {
        btnChange(bt){
            if(this.activeBtn) {
                this.tabs.map((x, i) => {
                    x.tabCss = i == bt ? "btn btn-primary" : "btn btn-outline-primary";
                    if(i == bt) {
                        this.$emit('changeTab',bt);
                    }
                    return x;
                });
            }
       },
       changeEnableTabCss() {
            this.tabs.map((x, i) => {
                x.tabCss = i == 0 ? "btn btn-primary" : "btn btn-outline-primary"
            });
       },
       changeDisableTabCss(){
            this.tabs.map((x, i) => {
                x.tabCss = i == 0 ? "btn btn-primary" : "btn btn-nonActive"
            });
       }       
    },
}
</script>